module.exports = __webpack_public_path__ + "img/Impuestos.63974065.png";